<div class="main-container" [class.show-mock-phone]="isShowingLargeJoinInfo">
  <mat-sidenav-container
    [class.opened]="opened"
    class="sidenav-import-container"
  >
    <mat-sidenav
      #sidenav
      mode="side"
      [(opened)]="opened"
      class="import-sidenav"
    >
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="import-items-container">
        <div class="import-items">
          <div class="import-items-list">
            <h1>
              {{ getTitle() }}
            </h1>
            <qa-content-spinner [active]="loading">
              @if (!loading) {
              <div class="list">
                <qa-grid-data
                  [selectedRows]="selectedRows"
                  [disabledRows]="selectedRows"
                  (selectedEntities)="setSelectedItems($event)"
                  [config]="listConfig"
                  [isSingleSelection]="convertToEvent"
                  #list
                ></qa-grid-data>
              </div>
              }
            </qa-content-spinner>
          </div>
          @if (!loading) {
          <div class="actions flex-column flex-justify-space-between">
            @if (selectedItemsToImport?.length) {
            <div class="table">
              <h3>
                {{ selectedItemsToImport.length }}&nbsp;{{
                  getSelection()
                }}&nbsp;
                {{ 'importItemDialog.selection' | translate }}
              </h3>
              <mat-table
                [dataSource]="selectedItemsToImport"
                class="mat-elevation-z8"
              >
                @for (column of listConfig.columns; track column.name) {
                <ng-container [matColumnDef]="column?.name">
                  <mat-header-cell
                    [style.flex]="column?.width ? '0 0 ' + column.width : null"
                    *matHeaderCellDef
                  >
                    {{ column?.label }}
                  </mat-header-cell>
                  <mat-cell
                    [style.flex]="column?.width ? '0 0 ' + column.width : null"
                    *matCellDef="let row"
                  >
                    {{
                      column.accessor ? column.accessor(row) : row[column.name]
                    }}
                  </mat-cell>
                </ng-container>
                }
                <ng-container matColumnDef="actions">
                  <mat-header-cell
                    [style.flex]="'0 0 48px'"
                    *matHeaderCellDef
                  ></mat-header-cell>
                  <mat-cell
                    [style.flex]="'0 0 48px'"
                    *matCellDef="let row; let i = index"
                  >
                    <button
                      (click)="removeSelection(row)"
                      color="primary"
                      mat-icon-button
                      type="button"
                    >
                      <mat-icon> delete </mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row
                  *matHeaderRowDef="displayedColumnNames"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumnNames"
                  [ngClass]="{ highlight: selectedItem == row.id }"
                ></mat-row>
              </mat-table>
            </div>
            } @if (selectedItemsToImport?.length < 1) {
            <div class="table">
              <h3>
                {{ selectedItemsToImport.length }}&nbsp;{{
                  getSelection()
                }}&nbsp;
                {{ 'importItemDialog.selection' | translate }}
              </h3>
              <h5 class="no-selectedItem">{{ emptySelection() }}</h5>
            </div>
            }
            <div class="import-actions flex-align-right">
              <qa-button
                (submitted)="goBack()"
                label="common.button.cancel"
              ></qa-button>
              <qa-button
                [isRaisedButton]="true"
                [disabled]="!selectedItemsToImport?.length"
                (submitted)="importContent()"
                data-cy="import"
                label="common.button.import"
              ></qa-button>
            </div>
          </div>
          } @if (isShowingLargeJoinInfo) {
          <div class="show-large-info" [@enterAnimation]>
            <div class="close-panel">
              <mat-icon
                (click)="
                  isShowingLargeJoinInfo = false;
                  listConfig.selectedEntityId = null
                "
                >arrow_forward_ios</mat-icon
              >
            </div>
            <div class="mock-phone-container">
              <div class="mock-phone">
                <ng-scrollbar>
                  @if ( input?.type == panelEntityType.Question || input?.type
                  == panelEntityType.ExamQuestion || input?.type ==
                  panelEntityType.EventQuestion ) {
                  <qa-question-mock-phone
                    [question]="selectedItem"
                  ></qa-question-mock-phone>
                  } @if (input?.type == panelEntityType.FlashCard) {
                  <qa-flash-card-mock-phone [flashCard]="selectedItem">
                  </qa-flash-card-mock-phone>
                  }
                </ng-scrollbar>
              </div>
            </div>
            <!-- <div class="add-item flex-row flex-justify-content-end">
                <button
                  color="primary"
                  (click)="addEntity()"
                  [disabled]="checkDisabled(selectedItem)"
                  mat-button
                  type="button"
                  >
                  <mat-icon>done</mat-icon>
                  {{
                  input?.type == panelEntityType.Question
                  ? ('Add question' | translate)
                  : ('Add Fash Card' | translate)
                  }}
                </button>
              </div> -->
          </div>
          }
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
